/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import OfferBox from './OfferBox';
import OfferTitle from './OfferTitle';

import { PAGE_OFFER } from '../../../config/pages';
import Link from '../../helpers/Link';

const OfferList = ({
    t, openPage, language, page, subpage, pageTransitionState, offer
}) => (
    <div className="container-offer-content" id="container-offer-content">
        <div className="layout">
            <div className="page-offer-content" id="page-offer-content">
                <OfferTitle t={ t } title={ offer.header.translations.title }/>
                <h3 className="offer-subtitle" id="offer-subtitle">
                    { offer.header.translations.subtitle }
                </h3>
                <div className="offer-boxes" id="offer-boxes">
                    {
                        offer.items.map((item, index) => (
                            <OfferBox
                              key={ item.translations.slug }
                              t={ t }
                              openPage={ openPage }
                              language={ language }
                              page={ page }
                              pageTransitionState={ pageTransitionState }
                              offer={ item }
                              active={ subpage === item.translations.slug }
                              index={ index }
                              totalItems={ offer.items.length }
                            />
                            ))
                    }
                </div>
                {
                    (page === PAGE_OFFER && (
                        <div className="threats-security-buttons-wrapper">
                            {offer.ctas.map((cta, index) => (
                                <div className="threats-security-button" id={ `security-${ index }-button-1` } key={ `security-${ index }-button-1` }>
                                    <Link
                                      openPage={ openPage }
                                      language={ language }
                                      page={ cta.translations.path.slice(1) }
                                      id={ `security-${ index }-button-2` }
                                    >
                                        { cta.translations.text }
                                    </Link>
                                </div>
                        ))}
                        </div>
                    ))
                }
            </div>
        </div>
    </div>
);

OfferList.defaultProps = {
    subpage: null
};

OfferList.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    subpage: PropTypes.string,
    pageTransitionState: PropTypes.string.isRequired,
    offer: PropTypes.shape().isRequired
};

export default OfferList;



// WEBPACK FOOTER //
// ./src/components/content/offer/OfferList.jsx